import ApiService from "@/core/services/api.service";
import { normalizeBranchesForApi } from "@/services/balanceSheetReport.service";

/**
 * Income statement is as-at a single date: only endDate drives the report cutoff.
 * Do not send startDate — the API ignores it if present.
 * If endDate is omitted, the server defaults to the current financial year end.
 * terms: YTD (default) | Periodic. branches: same semantics as balance sheet (omit = all).
 */

/**
 * @param {object} form — end_date (as-at / report date), terms, branches. Never send startDate.
 */
export function buildIncomeStatementRequestBody(form) {
	const body = {};
	if (form?.end_date) {
		body.endDate = form.end_date;
	}
	const terms =
		form?.terms != null && String(form.terms).trim() !== ""
			? form.terms
			: "YTD";
	body.terms = terms;
	const branches = normalizeBranchesForApi(form?.branches);
	if (branches !== undefined) {
		body.branches = branches;
	}
	return body;
}

/**
 * POST …/income-statement — full report (no layout segment).
 * POST …/income-statement/summary/{layout?} — summary; layout in path is cosmetic only.
 */
export function incomeStatementReportPath({ summary, layout }) {
	const base = "reports/financials/income-statement";
	if (summary) {
		const slug =
			layout != null && String(layout).trim() !== ""
				? `/${encodeURIComponent(String(layout).trim())}`
				: "";
		return `${base}/summary${slug}`;
	}
	return base;
}

export function postIncomeStatementReport({ summary, layout, form }) {
	const path = incomeStatementReportPath({ summary, layout });
	const body = buildIncomeStatementRequestBody(form);
	return ApiService.post(path, body);
}

export function unwrapIncomeStatementPayload(response) {
	const d = response?.data;
	if (!d) return {};
	if (d.incomes != null || d.expenses != null) {
		return d;
	}
	if (
		d.data &&
		typeof d.data === "object" &&
		(d.data.incomes != null || d.data.expenses != null)
	) {
		return d.data;
	}
	return typeof d === "object" ? d : {};
}
